import Dispatcher from '../dispatcher/CentricDispatcher.react.js';
import { ReduceStore } from 'flux/utils';
import { ActionTypes } from '../constants/CentricConstants';

const initialData = {
    errors: [],
    warnings: [],
    successCount: 0,
    totalProcessedCount: 0
};

class ModuleImportStore extends ReduceStore {

    getInitialState() {
        return {
            targetFile: {},
            data: initialData,
            isProcessed: false,
            isSuppressedSuccessMessage: false
        };
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.MODULE_IMPORT_SET_TARGET_FILE:
                return Object.assign({}, state, {
                    targetFile: action.payload
                });
            case ActionTypes.MODULE_IMPORT_REQUEST:
                return Object.assign({}, state, {
                    data: initialData,
                    isProcessed: false,
                    isSuppressedSuccessMessage: true
                });
            case ActionTypes.MODULE_IMPORT_SUCCESS:
                return Object.assign({}, state, {
                    data: action.data,
                    isProcessed: true,
                    isSuppressedSuccessMessage: false
                });
            case ActionTypes.MODULE_IMPORT_FAILURE:
                return Object.assign({}, state, {
                    isProcessed: true,
                    isSuppressedSuccessMessage: false
                });
            case ActionTypes.MODULE_IMPORT_SET_PROCESSED:
                return Object.assign({}, state, {
                    isProcessed: !!action.payload
                });
            default:
                return state;
        }
    }
}

export default new ModuleImportStore(Dispatcher);
